import React from "react";
import About from "@/components/navigation/About";
import Services from "@/components/navigation/Services";
import Resources from "@/components/navigation/Resources";
import {
  AccreditationSmallSection,
  Header,
  HeaderSection,
} from "@/.storyblok/types/319751/storyblok-components";
import { SbBlokData } from "@storyblok/react";

interface DesktopProps {
  blok?: Header & SbBlokData;
  trustsmall?: AccreditationSmallSection & SbBlokData;
}

const Desktop: React.FC<DesktopProps> = ({ blok, trustsmall }) => {
  const sections = blok?.navigation_sections ?? [];

  if (sections.length === 0) return null;

  return (
    <div
      className="navbar-expand-lg flex-grow-1 d-none d-lg-block"
      id="page-navigation-desktop"
    >
      <ul className="navbar-nav">
        {sections.map((section) => {
          const { title, component, _uid, is_nested, link } = section;

          if (!title || !component) return null;

          return (
            <li
              key={_uid}
              className="nav-item me-2"
              id={`navbar-${title.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {is_nested ? (
                <div className="dropdown dropdown-navbar-offcanvas">
                  <a
                    href="#"
                    className="nav-link dropdown-toggle"
                    id={`dropdown-${title.toLowerCase()}`}
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {title}
                    <i className="fas fa-angle-down fa-sm ms-2 dropdown-arrow-icon"></i>
                  </a>
                  {component === "header_section" && title === "Services" && (
                    <Services blok={section as HeaderSection & SbBlokData} trustsmall={trustsmall}  />
                  )}
                  {component === "header_section" && title === "About" && (
                    <About blok={section as HeaderSection & SbBlokData} />
                  )}
                  {component === "header_section" && title === "Resources" && (
                    <Resources
                      blok={section as HeaderSection & SbBlokData}
                      trustsmall={trustsmall}
                      latestBlog={blok?.latest_blog}
                    />

                  )}
                </div>
              ) : (
                <a
                  href={link?.url || "#"}
                  className="nav-link"
                  id={`link-${title.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {title}
                </a>
              )}
            </li>
          );
        })}
      </ul>

    </div>
  );
};

export default Desktop;